// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html {\n  width: 100% !important;\n}\n\n.efo-cat-main,\niframe {\n  height: 100%;\n  width: 100% !important;\n  max-width: 100% !important;\n}\n\n.efo-cat-main {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999999999;\n  display: flex;\n  flex-direction: column;\n}\n\n#cat-dummy-layer {\n  z-index: 2010;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 120%;\n  background: #fff;\n}", ""]);
// Exports
module.exports = exports;
